var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.93 572.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 50;\n        stroke-width: 37.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.68,18.75H111.31L18.81,297.25c-.21.66.16,1.36.82,1.57.1.03.2.05.31.06h106.12c.69-.03,1.27.5,1.31,1.19,0,.15-.01.29-.06.43l-82.13,245.5c-1.09,3.28.69,6.81,3.97,7.9,2.59.86,5.44-.06,7.03-2.27l247.75-340.12c.41-.55.3-1.34-.25-1.75-.22-.16-.48-.25-.75-.25h-111.37c-.75-.08-1.3-.76-1.21-1.52.01-.12.04-.24.09-.36L283.81,20.13c.07-.69-.43-1.3-1.11-1.37,0,0,0,0-.01,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsWhite);
export default __webpack_public_path__ + "static/media/Leads White.982d2220d6f1543cf95b3b8b139252a2.svg";
export { ForwardRef as ReactComponent };